const { jQuery: $ } = window;

import Utils from "./utils.class";
import MarketoValidator from "./MarketoValidator.class";
import MarketoPlugin from "./MarketoPlugin.class";

export default class Marketo {
    #id;
    #domain;
    #url;
    #marketoLoaded = false;
    #blockedDomains;
    #freeEmailDomains;
    #formAutosetValues;
    #plugins = [];

    constructor(id, domain, mktoHost, bannedDomains, freeDomains, autoValues) {
        this.#id = id;
        this.#domain = domain;
        this.#url = mktoHost;
        this.#blockedDomains = bannedDomains;
        this.#freeEmailDomains = freeDomains;
        this.#formAutosetValues = autoValues;

        $(window).on("load", function () {
            setTimeout(function () {
                $(".js-mkto-hide").show();
            }, 3000);
        });

        $(window).one("kmdg_marketo_ready", () => {
            $(".js-mkto-hide").addClass("js-hidden");
            this.#initPlugins();
        });
    }

    load() {
        // Async load marketo forms and set up global email validation rules

        Utils.log("Loading Marketo...");
        const self = this;

        if (!this.#marketoLoaded) {
            this.#marketoLoaded = true;

            $.getScript("https://" + this.#url + "/js/forms2/js/forms2.js", () => {

                MktoForms2.whenReady((form) => {
                    this.#floatLabel('.mktoFormRow .mktoField');
                    let urlParams = Utils.URLSearchParams;
                    let utm_medium = this.#formAutosetValues[urlParams.get("utm_medium")];

                    form._emailValidation = false;

                    form.addHiddenFields({
                        "utm_campaign": urlParams.get("utm_campaign"),
                        "utm_medium": urlParams.get("utm_medium"),
                        "utm_source": urlParams.get("utm_source"),
                        "utm_content": urlParams.get("utm_content"),
                        "GA_CID__c": "",
                        "leadSourceMR": "",
                    });

                    if (utm_medium === undefined) {
                        Utils.log("Autofilling Lead Source: Web");
                        form.setValues({'leadSourceMR': 'Web'});
                    } else {
                        Utils.log("Autofilling Lead Source: ", utm_medium);
                        form.setValues({'leadSourceMR': utm_medium});
                    }

                    try {
                        form.setValues({"GA_CID__c": ga.getAll()[0].get("clientId")});
                    } catch (e) {
                        Utils.log("Unable to set clientId");
                    }

                    form.getFormElem().find(".mktoEmailField").on('change', () => {
                        form._emailValidation = false;
                    });

                    form.getFormElem().find('.mktoButton').on('click', function () {
                        let $btn = $(this);
                        setTimeout(function () {
                            $btn.attr("disabled", "disabled");
                        }, 1);
                    });

                    form.onValidate((success) => {
                        Utils.log("Marketo Validation: ", success);

                        if (!success) {
                            // Restore access to the button after a few moments.
                            setTimeout(() => {
                                form.getFormElem().find('.mktoButton').removeAttr("disabled");
                            }, 3000);
                        }
                    });

                    form.onSubmit(() => {
                        let success = form.validate();

                        Utils.log("Running Custom Validation...");

                        success = MarketoValidator.runTasks(form, success);

                        Utils.log("Validation results: ", success ? "Success" : "Failed");

                        form.submittable(success);

                        if (!success) {
                            // Restore access to the button after a few moments.
                            setTimeout(function () {
                                form.getFormElem().find('.mktoButton').removeAttr("disabled");
                            }, 3000);
                        }

                        setTimeout(function () {
                            form.submittable(true);
                        }, 1);
                    });
                });

                MarketoValidator.registerTask("Default Validation", function ($) {
                    let email = this.vals().Email || this.vals().Email_Address_L__c;

                    if (email) {
                        if (!Utils.isEmailGood(self.#blockedDomains, email)) {
                            // Found competitor email, fake thank you message.
                            this.getFormElem().html("<p style='text-align: center;font-size: 100%;'>Thank you for your interest, you will hear from us soon.</p>");
                            return false;
                        } else if (!Utils.isEmailGood(self.#freeEmailDomains, email)) {
                            let $emailEl = this.getFormElem().find(".mktoEmailField");

                            Utils.log("Email Error: Not business email.");

                            // Allow marketo errors to be displayed until the next time the field is clicked on (conflict with this.#neverbounce)
                            $emailEl.parent().addClass("show_errors").one("click", function () {
                                $(this).removeClass('show_errors');
                            });

                            this.showErrorMessage("Please enter a business email.", $emailEl);
                            return false;
                        }
                    }

                    return true;
                });

                Utils.log("Marketo loaded.");
                $(window).trigger("kmdg_marketo_ready", [this, MarketoValidator]);
            });
        } else {
            Utils.log("Marketo already loaded.")
        }
    }

    #floatLabel(inputType) {
        $(inputType).each(function () {
            let $this = $(this);
            const $parent = $this.closest('.mktoFieldWrap');

            $this.attr('placeholder', '');
            $this.children().first().text('');
            $this.focus(function () {
                $parent.addClass('active').addClass('focus');
                $this.addClass('focused');
            });

            $this.blur(function () {
                $parent.removeClass('focus')
                if ($this.val() === '' || $this.val() === 'blank') {
                    if (!$this.is('#Phone')) {
                        $parent.removeClass('active')
                    }
                }
            });
        });
    }

    #initPlugins() {
        // Wait for signal that marketo is ready before loading plugins

        Utils.log("Loading Form Plugins...");

        $.getScript(location.protocol + "//" + location.host + "/wp-content/themes/kmdg/dist/js/SimpleDTO.min.js", () => {
            try {
                const DTO = new SimpleDTO({
                    domain: this.#domain,
                    dataSrc: "https://" + this.#url + "/dtp.html",
                    debug: true,
                    mode: "receive",
                    cb: (instance) => {
                        try {
                            const mktoFields = DTO.getGlobal()["mktoPreFillFields"];
                            DTO.cleanup();
                            MktoForms2.whenReady(function (form) {
                                const inputs = $('.mktoForm').find('.mktoField');
                                form.setValuesCoerced(mktoFields);
                                // Loop through prefilled inputs to apply active states
                                Array.prototype.forEach.call(inputs, input => {
                                    if (input && input.value) {
                                        $(input).parent('.mktoFieldWrap').addClass('active')
                                        $(input).addClass('mktoValid').change();
                                    }
                                })
                                Utils.log("Mkto: Prefilled fields.", mktoFields);
                                $(window).trigger("kmdg_marketo_dto_loaded", [form]);
                            });
                        } catch (e) {
                            Utils.log("Mkto: Could not pre-populate form.");
                            Utils.log(instance);
                        }
                    }
                });
            } catch (e) {
                Utils.log("DTO Failed to load (expected when not on main domain)");
            }
        });

        for(let i in this.#plugins) {
            Utils.log("Loading Mkto plugin:", this.#plugins[i].name);

            if(this.#plugins[i].class.prototype instanceof MarketoPlugin) {
                this.#plugins[i].class.marketoIntegration();
            } else {
                Utils.log("Error! Invalid plugin.");
            }
        }
    }

    registerPlugin(name, instance) {
        Utils.log("Registered Mkto plugin:", name);

        this.#plugins.push({
            name: name,
            class: instance
        });
    }

    get url() {
        return this.#url;
    }

    get id() {
        return this.#id;
    }
}